import { TestResult, EvalResult, SourceEvalResult } from '@/types/evals-types';
import { TestActionsHeader, TestResultTable } from './test-result-components';

// Helper to get all unique sources
function getAllSources(evalResults: EvalResult[]): string[] {
  const sources = new Set<string>();
  evalResults?.forEach((evalResult: EvalResult) => {
    evalResult.input_results.forEach((r: SourceEvalResult) =>
      sources.add(r.source_id),
    );
  });
  return Array.from(sources);
}

// Helper to get result for a source in a given eval
function getResultForSource(
  evalResult: EvalResult,
  sourceId: string,
): SourceEvalResult | undefined {
  return evalResult.input_results.find(
    (r: SourceEvalResult) => r.source_id === sourceId,
  );
}

interface TestResultsTableProps {
  testResults: TestResult[];
  onRerun?: (testId: string) => void;
  pollingTestId?: string | null;
}

export default function TestResultsTable({
  testResults,
  onRerun,
  pollingTestId,
}: TestResultsTableProps) {
  // Handle undefined or empty testResults
  if (!testResults || testResults.length === 0) {
    return (
      <div className='space-y-12'>
        <div className='text-gray-500'>No test results available.</div>
      </div>
    );
  }

  const firstTestResult = testResults[0];

  return (
    <div className='space-y-12'>
      <TestActionsHeader
        testResult={firstTestResult}
        onRerun={onRerun}
        pollingTestId={pollingTestId}
      />
      {testResults?.map((testResult) => (
        <TestResultTable
          key={testResult.id}
          testResult={testResult}
          getAllSources={getAllSources}
          getResultForSource={getResultForSource}
        />
      ))}
    </div>
  );
}
